(function () {
  "use strict";

  let searchSent = false;

  document.addEventListener(
    "submit",
    function (event) {
      if (searchSent) return;
      if (!(event.target instanceof HTMLFormElement)) return;

      const form = event.target;

      const searchInput =
        form.querySelector('input[type="search"]') ||
        form.querySelector('input[name="q"]');

      if (!searchInput) return;

      const searchTerm = searchInput.value.trim();

      if (!searchTerm) return;

      if (
        !window.klaviyo ||
        typeof window.klaviyo.track !== "function"
      ) {
        console.warn("Klaviyo ist nicht verfügbar.");
        return;
      }

      event.preventDefault();

      window.klaviyo
        .track("Suche durchgeführt", {
          Suchbegriff: searchTerm,
          Suchseite: window.location.href
        })
        .then(function () {
          searchSent = true;
          console.log("Suche durchgeführt sent to Klaviyo");
          form.submit();
        })
        .catch(function (error) {
          console.error("Fehler beim Suchtracking:", error);
          form.submit();
        });
    },
    true
  );
})();